import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

const filterSchema = z.object({
  category: z.enum(['Question', 'CustomerAttribute']),
  id: z.string(),
})

const schema = z.object({
  filters: z.array(filterSchema).min(1),
})
export type InputValues = z.infer<typeof schema>
export const resolver = zodResolver(schema)
